import React from 'react';
import {
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import DeleteIcon from '@material-ui/icons/Delete';
import RefreshIcon from '@material-ui/icons/Refresh';
import { apiBatchRequest, apiPost } from '../../utils/api_service';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
    IsSectionVisible,
    UpdateColumnWithConfiguration
} from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { SECTIONS } from '../../constants/appConstants';
import { cacheRefreshColumns } from '../../constants/MockData';
import _ from 'lodash';
import moment from 'moment';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';

export default class ConfigurationRefreshCache extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshCacheHistoryData: [],
            configuration: [],
            cacheCol: _.cloneDeep(cacheRefreshColumns),
            selectedRow: undefined,
            showWarningMessage: false,
            confirmMessage: '',
            isRefreshing: false
        };
    }

    componentDidMount() {
        this.getCacheHistory();
    }

    getCacheHistory = () => {
        this._asyncRequest = apiBatchRequest([
            {
                url: API_URL.Users.FetchRefreshCacheHistory,
                key: 'refreshCacheHistoryData'
            }
        ])
            .then(({ refreshCacheHistoryData }) => {
                this._asyncRequest = null;
                this.setState({
                    refreshCacheHistoryData: (refreshCacheHistoryData.data || []).map((item) => ({
                        ...item,
                        refreshedOn: item.refreshedOn
                            ? moment(item.refreshedOn).format('MM-DD-YYYY hh:mm A')
                            : ''
                    })),
                    configuration: refreshCacheHistoryData.config || []
                });
            })
            .catch((error) => {
                console.error('getCacheHistory failed:', error);
                this._asyncRequest = null;
                ShowToast(
                    'Failed to load cache history.',
                    toastType.ERROR,
                    5000,
                    500
                );
            });
    };



    onRefreshCache = () => {
        this.setState({ isRefreshing: true });

        apiPost({
            url: API_URL.Users.RefreshCache,
            key: 'refreshCache'
        })
            .then(({ data: response }) => {
                this.setState({ isRefreshing: false });
                if (response.success === true) {
                    ShowToast(
                        'Cache refreshed successfully.',
                        toastType.SUCCESS,
                        5000,
                        500
                    );
                    this.getCacheHistory();
                } else {
                    ShowToast(response.errorMessage, toastType.ERROR, 5000, 500);
                }
            })
            .catch(() => {
                this.setState({ isRefreshing: false });
                ShowToast(
                    'Failed to refresh cache.',
                    toastType.ERROR,
                    5000,
                    500
                );
            });
    };


    deleteRecord = (cellInfo) => {
        this.setState({
            showWarningMessage: true,
            confirmMessage:
                'Do you want to delete the cache record created by "' +
                cellInfo.createdBy +
                '"?',
            selectedRow: cellInfo
        });
    };

    onClickHandle = (confirmed) => {
        if (confirmed) {
            const { selectedRow } = this.state;
            apiPost({
                url: API_URL.Cache.DeleteCacheRecord,
                params: {},
                postBody: selectedRow.cacheId
            }).then(({ data: response }) => {
                if (response.success === true) {
                    ShowToast(
                        'Cache record deleted successfully.',
                        toastType.SUCCESS,
                        5000,
                        500
                    );
                    this.setState(
                        {
                            showWarningMessage: false,
                            confirmMessage: '',
                            selectedRow: undefined
                        },
                        () => this.getCacheHistory()
                    );
                } else {
                    ShowToast(response.errorMessage, toastType.ERROR, 5000, 500);
                }
            });
        } else {
            this.setState({ showWarningMessage: false, confirmMessage: '' });
        }
    };



    renderActionColumn = (cellInfo) => {
        const canDelete = IsSectionVisible(
            SECTIONS.CONFIGURATION,
            SECTIONS.REFRESH_CACHE,
            SECTIONS.ADD_EDIT
        );

        if (!canDelete) return null;

        return (
            <Tooltip title="Delete Record">
                <IconButton
                    size="small"
                    onClick={() => this.deleteRecord(cellInfo)}
                >
                    <DeleteIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        );
    };



    render() {
        const {
            refreshCacheHistoryData,
            configuration,
            cacheCol,
            isRefreshing,
            showWarningMessage,
            confirmMessage
        } = this.state;

        return (
            <>
                {/* Delete Confirmation Dialog */}
                {showWarningMessage && (
                    <ConfirmDialog
                        IsOpen={showWarningMessage}
                        Message={confirmMessage}
                        OnHandelClick={(isValid) => this.onClickHandle(isValid)}
                        AgreeText="Yes"
                        DisAgreeText="No"
                    />
                )}

                <Table
                    aria-labelledby="tableMenuTitle"
                    size="small"
                    aria-label="refresh cache table"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell
                                key="configureHeader"
                                className="content-header"
                                colSpan={2}
                            >
                                <div className="content-header d-flex">
                                    {/* Section Title — exactly like ContactRoles */}
                                    <div
                                        className="col-xs-11"
                                        style={{
                                            display: 'inline-block',
                                            alignItems: 'center'
                                        }}
                                    >
                                        Refresh Cache
                                    </div>
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <GridTable
                                    columns={UpdateColumnWithConfiguration(
                                        cacheCol,
                                        configuration,
                                        []
                                    )}
                                    data={refreshCacheHistoryData}
                                    config={cacheCol}
                                    // renderActionColumn={this.renderActionColumn}
                                    selectedEditRowId={undefined}
                                    isInAddMode={false}
                                    EditSource={[]}
                                    handleTableEditChange={() => { }}
                                    updateData={undefined}
                                    isInline={true}
                                    AddNewRecord={{
                                        action: this.onRefreshCache,
                                        title: isRefreshing ? 'Refreshing...' : 'Refresh Cache',
                                        visible: IsSectionVisible(
                                            SECTIONS.CONFIGURATION,
                                            SECTIONS.REFRESH_CACHE,
                                            SECTIONS.ADD_EDIT
                                        )
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        );
    }
}
